/** Slug + reserved names for /api/integrations/{slug}/webhook */

export const INBOUND_WEBHOOK_BUILTIN_SLUGS = ["inventory-host", "idearoom"] as const;
export type InboundWebhookBuiltinSlug = (typeof INBOUND_WEBHOOK_BUILTIN_SLUGS)[number];

const PATH_RESERVED = new Set([
  "fastfield",
  "quickbooks",
  "google-calendar",
  "google-drive",
  "ghl",
  "admin",
  "sign",
  "oauth",
  "callback",
  "webhook",
  "inbound",
]);

export const INBOUND_WEBHOOK_BUILTINS: ReadonlyArray<{
  slug: InboundWebhookBuiltinSlug;
  display_name: string;
}> = [
  { slug: "inventory-host", display_name: "Inventory host" },
  { slug: "idearoom", display_name: "IdeaRoom" },
];

export function slugifyInboundWebhookName(raw: string): string {
  return raw
    .trim()
    .toLowerCase()
    .replace(/['"]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 48);
}

export function isInboundWebhookBuiltinSlug(slug: string): slug is InboundWebhookBuiltinSlug {
  return (INBOUND_WEBHOOK_BUILTIN_SLUGS as readonly string[]).includes(slug);
}

/** Named-webhook slug → `ops_integration_events.source` (inventory-host stores underscore). */
export function eventSourceForInboundSlug(slug: string): string {
  const s = slug.trim().toLowerCase();
  if (s === "inventory-host") return "inventory_host";
  return s;
}

export function inboundWebhookCreateError(slug: string): string | null {
  if (!slug) return "Name must include a letter or number.";
  if (PATH_RESERVED.has(slug)) return `"${slug}" is reserved for another integration path.`;
  if (isInboundWebhookBuiltinSlug(slug)) {
    return `"${slug}" is already a built-in inbound webhook for this org.`;
  }
  return null;
}

export function inboundNameFromRequest(req: { query?: Record<string, unknown>; url?: string }): string {
  const q = req.query?.name;
  const fromQuery = Array.isArray(q) ? q[0] : q;
  if (typeof fromQuery === "string" && fromQuery.trim()) {
    return fromQuery.trim().toLowerCase();
  }
  const url = typeof req.url === "string" ? req.url : "";
  const m = url.match(/\/api\/integrations\/([^/?#]+)\/webhook/i);
  return m?.[1]?.trim().toLowerCase() ?? "";
}
